(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["revesyn-contact-form"] && !Shopify.designMode) return;
  try {
    
  const focusRevesynContactStatus = () => {
    const status = document.querySelector('#contact-form [data-revesyn-contact-status]');
    if (status) {
      status.focus();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', focusRevesynContactStatus, { once: true });
  } else {
    focusRevesynContactStatus();
  }

  } catch(e) { console.error(e); }
})();
})();
